const moment = require('moment');
const { IsEmpty, IsString } = require('./checks');

const DateUtil = {
  // If we use "new Date('Fri Apr 16 2021 16:00:00 GMT+0800 (GMT))"
  // the returned date object will still be in UTC+0 in our remote server.
  // Appears we need to convert the date object to a locale string with timeZone set
  // and pass it in the Date contructor so that it will return in UTC+08
  ConvertDateToSGTime: (date) => {
    if (!(date instanceof Date)) {
      throw new Error('ConvertDateToSGTime(): input date is not a Date type');
    }
    return new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Singapore' }));
  },

  CreateDate: (daysFromCurDate = 0) => moment().add(daysFromCurDate, 'days').toDate(),

  /**
   * Returns the SGT date based on the input date and number of months. Can customise output date format using 'format'.
   * @param {*} date
   * @param {*} numOfMonths
   * @param {*} format e.g 'YYYY-MM-DD hh:mm:ss'
   * @returns default returns in format 'YYYY-MM-DD'
   */
  CreateSGUTCDateMonthsFrom: (date, numOfMonths, format = 'YYYY-MM-DD') => moment(date).add(numOfMonths, 'months').utcOffset('+08:00').format(format),

  /**
   * Formats the given date into a string in Local time.
   * @param {*} date
   * @param {*} format e.g 'YYYY-MM-DD hh:mm:ss'
   * @returns default returns in format 'DD MMM YYYY, h:mm A'
   */
  FormatLocalDateAndTime: (date, format = 'DD MMM YYYY, h:mm A') => moment(date).format(format),

  /**
   * Calculate the expiry date num of months from date in GMT+08 in 23:59:59 hours.
   * E.g. 1 month expiry from 1st Jan shall return expiry date = 31st Jan 23:59:59.
   * E.g. 0 month and 1 day represents the end of the day itself
   * NOTE: if both month & day are null or value 0, then expiry date is yesterday's end of day
   * @param {*} date
   * @param {*} numberOfMonths
   * @param {*} numberOfDays
   * @returns
   */
  CalulateExpiryDateInSGT: (date, numberOfMonths, numberOfDays) => {
    const kMonthsAndDaysFromDate = moment(date).add(numberOfMonths || 0, 'months').add(numberOfDays || 0, 'days').utcOffset('+08:00');
    return new Date(`${moment(kMonthsAndDaysFromDate).subtract(1, 'day').format('YYYY-MM-DD')} 23:59:59+08`);
  },

  GetCurrentDate: () => new Date(),

  GetCurrentSGDateTime: () => {
    // this function converts date & time to local SGT regardless of timezones.
    const current = DateUtil.GetCurrentDate();
    return DateUtil.ConvertDateToSGTime(current);
  },

  /**
   * If input is a string, method will convert it into a date
   * @param {*} date - expect a Date object or a String representing a date
   * @returns a date object with hour, min and sec set to zero. If input is null, returns null.
   */
  RemoveHourMinSec: (date) => {
    if (IsEmpty(date)) {
      return null;
    }
    if (IsString(date)) {
      date = new Date(date);
    }

    if (date instanceof Date) {
      return date.setHours(0, 0, 0, 0);
    } else {
      return date;
    }
  },

  GetMonth: (date) => {
    if (IsEmpty(date)) {
      return null;
    }
    if (IsString(date)) {
      date = DateUtil.GetCurrentSGDateTime();
    }
    if (date instanceof Date) {
      date.setHours(0, 0, 0, 0);
      const month = date.getMonth();
      return month;
    } else {
      return date;
    }
  },

  GetMonthExtra: (date) => {
    if (IsEmpty(date)) {
      return null;
    }
    if (IsString(date)) {
      date = DateUtil.GetCurrentSGDateTime();
    }
    if (date instanceof Date) {
      date.setHours(0, 0, 0, 0);
      date = new Date(date.setDate(date.getDate() + 30));
      const month = date.getMonth();
      return month;
    } else {
      return date;
    }
  },

  GetYear: (date) => {
    if (IsEmpty(date)) {
      return null;
    }
    if (IsString(date)) {
      date = DateUtil.GetCurrentSGDateTime();
    }
    if (date instanceof Date) {
      date.setHours(0, 0, 0, 0);
      const year = date.getFullYear();
      return year;
    } else {
      return date;
    }
  },

  /**
   * The input 'date' string is assumed to be in the format 'yyyy-mm-dd'.
   * Function will compare input date with system'sdate with the timezones in consideration, and compare the date part.
   * Refer to test case for examples.
   * @param {*} date
   * @returns true or false
   */
  IsDateInTheFuture: (date = '') => !IsEmpty(date)
    && moment(date).utcOffset('+08:00').startOf('day')
      .isAfter(moment(DateUtil.GetCurrentDate()).utcOffset('+08:00').startOf('day')),
};

module.exports = DateUtil;
